import { render, staticRenderFns } from "./FlippedClassConfig.vue?vue&type=template&id=db6d0736"
import script from "./FlippedClassConfig.vue?vue&type=script&lang=js"
export * from "./FlippedClassConfig.vue?vue&type=script&lang=js"
import style0 from "./FlippedClassConfig.vue?vue&type=style&index=0&id=db6d0736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports